module.exports = "/resources/assets/prod/75927e55b8e31f14f9ab83fb9df3b94f.svg";